import { render } from "./ThemeArtworkSkeleton.vue?vue&type=template&id=d5e1bbae&scoped=true"
const script = {}

import "./ThemeArtworkSkeleton.vue?vue&type=style&index=0&id=d5e1bbae&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e1bbae"]])

export default __exports__